// Angular imports
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Service imports
import { HelperService } from '../../../_services/shared-services/helper.service';
import { PrecisionService } from '../../../_services/shared-services/precision.service';
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { TimeExpenseComfirmationService } from '../../_services/time-expense-confirmation.service';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// 3rd party imports
import { Observable } from 'rxjs';
import notify from 'devextreme/ui/notify';

// Constant imports
import { MessageInterval } from '../../../_constants/messages-intervals';
import { StringFormatConstants } from '../../../_constants/string-format-constants';

// Model imports
import { TimeExpenseEmailSubmissionSaveNoteParameterDto } from '../../_models/time-expense-email-submission-save-note-parameter-dto';

@Component({
    selector: 'app-time-expense-report-master-detail-grid',
    templateUrl: './time-expense-report-master-detail-grid.component.html',
    styleUrls: ['./time-expense-report-master-detail-grid.component.scss']
})
export class TimeExpenseReportMasterDetailGridComponent {
    @Input() userId: string;
    @Input() selectedTab: any;
    @Input() submissionId: string;
    @Input() selectedExpenseTabDatail: any[] = [];

    @Output() onNoteUpdate = new EventEmitter<void>();

    notesVisible = false;
    selectedExpense: any;
    currencyFormat: string;
    dateFormat = StringFormatConstants.dateFormat;

    iconNotes = IconConstants.NOTES_AVAILABLE;
    iconEmptyNotes = IconConstants.NOTES_EMPTY;

    constructor(
        private readonly helperService: HelperService,
        private readonly errorService: ServerErrorService,
        private readonly precisionService: PrecisionService,
        private readonly timeExpenseSubService: TimeExpenseComfirmationService
    ) {
        this.currencyFormat = this.precisionService.getCurrencyFormat();
        this.calculateCustomSummary = this.calculateCustomSummary.bind(this);
    }

    onShown(e: any): void {
        e.component.repaint();
    }

    calculateCustomSummary(e: any): void {
        this.helperService.calculateTotalSummary(e);
    }

    onNotesClick(rowData: any): void {
        this.selectedExpense = rowData;
        this.notesVisible = true;
    }

    onNotesPopClose(): void {
        this.notesVisible = false;
    }

    onSaveNotes(newNote: string): void {
        if (Utils.notNullOrEmpty(newNote)) {
            this.updateNotes(newNote);
        }
    }

    private updateNotes(newNote: string): void {
        this.timeExpenseSubService.showLoading();

        const params = new TimeExpenseEmailSubmissionSaveNoteParameterDto();
        params.entryId = this.selectedExpense.entryId;
        params.submissionId = this.submissionId;
        params.userId = this.userId;
        params.newNote = newNote;

        let updateNotes: Observable<any>;

        if (Utils.equalsIgnoreCase(this.selectedTab.name, 'timeExpense')) {
            updateNotes = this.timeExpenseSubService.updateTimeNotes(params);
        } else if (Utils.equalsIgnoreCase(this.selectedTab.name, 'generalExpense')) {
            updateNotes = this.timeExpenseSubService.updateExpenseNotes(params);
        } else if (Utils.equalsIgnoreCase(this.selectedTab.name, 'mileageExpense')) {
            updateNotes = this.timeExpenseSubService.updateMileageNotes(params);
        }

        updateNotes.subscribe(
            () => {
                this.onNoteUpdate.emit();
                this.timeExpenseSubService.hideLoading();
                this.onNotesPopClose();
                notify('Notes has been updated successfully', 'success', MessageInterval.successMsgInterval);
            },
            (error: HttpErrorResponse) => {
                this.errorService.displayError(error);
                this.timeExpenseSubService.hideLoading();
            }
        );
    }
}
